(function () {

  function getMediaGroupFromElement(element) {
    return element ? element.getAttribute('data-group') || '' : '';
  }

  function getSelectedIndex(slideshow) {
    var selectedSlide = slideshow.querySelector('.product-main-slide.is-selected');

    if (!selectedSlide) {
      selectedSlide = slideshow.querySelector('.product-main-slide.starting-slide');
    }

    if (!selectedSlide) {
      selectedSlide = slideshow.querySelector('.product-main-slide');
    }

    var selectedIndex = selectedSlide ? parseInt(selectedSlide.getAttribute('data-index'), 10) : 0;

    return isNaN(selectedIndex) ? 0 : selectedIndex;
  }

  function getActiveThumbItem(gallery, index) {
    var indexedThumb = gallery.querySelector('.product__thumb-item[data-index="' + index + '"]:not(.hide)');

    if (indexedThumb) {
      return indexedThumb;
    }

    var activeThumb = gallery.querySelector('[data-product-thumb].is-active');

    if (activeThumb) {
      return activeThumb.closest('.product__thumb-item');
    }

    return gallery.querySelector('.product__thumb-item[data-index="' + index + '"]');
  }

  function getFlickitySelectedIndex(flickity) {
    var selectedElement = flickity.selectedElement;

    if (!selectedElement && flickity.cells && flickity.cells[flickity.selectedIndex]) {
      selectedElement = flickity.cells[flickity.selectedIndex].element;
    }

    if (selectedElement) {
      var elementIndex = parseInt(selectedElement.getAttribute('data-index'), 10);

      if (!isNaN(elementIndex)) {
        return elementIndex;
      }
    }

    return Number.isInteger(flickity.selectedIndex) ? flickity.selectedIndex : 0;
  }

  function getActiveMediaGroup(gallery, slideshow, index) {
    var activeItem = getActiveThumbItem(gallery, index);
    var activeSlide = slideshow.querySelector('.product-main-slide.is-selected') ||
      slideshow.querySelector('.product-main-slide.starting-slide');
    var group = getMediaGroupFromElement(activeItem) || getMediaGroupFromElement(activeSlide);

    if (group) {
      return group;
    }

    var firstGroupedItem = gallery.querySelector('.product__thumb-item[data-group]:not(.hide)');

    return getMediaGroupFromElement(firstGroupedItem);
  }

  function isThemeVisible(item) {
    var style = window.getComputedStyle(item);

    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function updateProductThumbVisibility(gallery, slideshow) {
    var index = getSelectedIndex(slideshow);
    var group = getActiveMediaGroup(gallery, slideshow, index);
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__thumb-item'));

    items.forEach(function (item) {
      var itemGroup = getMediaGroupFromElement(item);
      var shouldHide = group && itemGroup && itemGroup !== group;

      if (shouldHide) {
        item.classList.add('product__thumb-item--mc-hidden');
      } else {
        item.classList.remove('product__thumb-item--mc-hidden');
      }
    });
  }

  function getGalleryThumbItems(gallery, slideshow, index) {
    var group = getActiveMediaGroup(gallery, slideshow, index);
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__thumb-item'));

    if (group) {
      return items.filter(function (item) {
        return getMediaGroupFromElement(item) === group;
      });
    }

    return items.filter(isThemeVisible);
  }

  function updateProductGalleryCount(gallery, index) {
    var slideshow = gallery ? gallery.querySelector('[data-product-photos]') : null;

    if (!gallery || !slideshow) {
      return;
    }

    var counter = gallery.querySelector('[data-product-gallery-current]');
    var total = gallery.querySelector('[data-product-gallery-total]');
    var visibleItems = getGalleryThumbItems(gallery, slideshow, index);
    var activeItem = getActiveThumbItem(gallery, index);
    var currentIndex = index;

    if (!counter) {
      return;
    }

    if (visibleItems.length) {
      currentIndex = visibleItems.indexOf(activeItem);

      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    counter.textContent = String(currentIndex + 1);

    if (total) {
      total.textContent = String(visibleItems.length || 1);
    }
  }

  function refreshProductGallery(gallery, slideshow) {
    updateProductThumbVisibility(gallery, slideshow);
    updateProductGalleryCount(gallery, getSelectedIndex(slideshow));
  }

  function scheduleProductGalleryRefresh(gallery, slideshow) {
    window.setTimeout(function () {
      refreshProductGallery(gallery, slideshow);
    }, 80);
  }

  function refreshAllProductGalleries() {
    var galleries = document.querySelectorAll('[data-product-images]');

    galleries.forEach(function (gallery) {
      var slideshow = gallery.querySelector('[data-product-photos]');

      if (slideshow) {
        scheduleProductGalleryRefresh(gallery, slideshow);
      }
    });
  }

  function getCurrentProductVariant(productSection) {
    var currentVariantJson = productSection.querySelector('[data-current-variant-json]');

    if (!currentVariantJson) {
      return null;
    }

    try {
      return JSON.parse(currentVariantJson.value || currentVariantJson.textContent);
    } catch (error) {
      return null;
    }
  }

  function updateLowStockMessage(productSection, selectedVariant) {
    var message = productSection.querySelector('[data-mc-low-stock-message]');
    var lowStockJson = productSection.querySelector('[data-mc-low-stock-data]');

    if (!message || !lowStockJson) {
      return;
    }
    if (productSection.matches('[data-mc-georgina]') && !productSection.querySelector('[data-mc-size-input]:checked')) {
      message.hidden = true;
      return;
    }

    var variant = selectedVariant || getCurrentProductVariant(productSection);
    var lowStockData;

    try {
      lowStockData = JSON.parse(lowStockJson.textContent);
    } catch (error) {
      return;
    }

    var variantLowStockData = lowStockData.find(function (item) {
      return variant && String(item.id) === String(variant.id);
    });
    var quantity = variantLowStockData ? Number(variantLowStockData.count) : 0;
    var shouldShow = Number.isInteger(quantity) && quantity > 0 && variantLowStockData.available && variant && variant.available;

    message.hidden = !shouldShow;

    if (shouldShow) {
      var count = message.querySelector('[data-mc-low-stock-count]');

      if (count) {
        count.textContent = String(quantity);
      }
    }
  }

  function initLowStockMessages(scope) {
    var productSections = (scope || document).querySelectorAll('.product-section');

    productSections.forEach(function (productSection) {
      updateLowStockMessage(productSection);
    });
  }

  function initProductGalleryCounts(scope) {
    var galleries = (scope || document).querySelectorAll('[data-product-images]');

    galleries.forEach(function (gallery) {
      if (gallery.dataset.mcGalleryCountReady === 'true') {
        return;
      }

      var slideshow = gallery.querySelector('[data-product-photos]');

      if (!slideshow) {
        return;
      }

      gallery.dataset.mcGalleryCountReady = 'true';
      refreshProductGallery(gallery, slideshow);

      // Product photos remain passive; only the magnifier opens the gallery.

      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-product-thumb]');

        if (!thumb) {
          return;
        }

        var index = parseInt(thumb.getAttribute('data-index'), 10);

        if (!isNaN(index)) {
          updateProductThumbVisibility(gallery, slideshow);
          updateProductGalleryCount(gallery, index);
        }
      });

      var selectedSlideRefreshQueued = false;
      var selectedSlideObserver = new MutationObserver(function (mutations) {
        var selectionChanged = mutations.some(function (mutation) {
          return mutation.target.classList && mutation.target.classList.contains('product-main-slide');
        });

        if (!selectionChanged || selectedSlideRefreshQueued) {
          return;
        }

        selectedSlideRefreshQueued = true;

        window.requestAnimationFrame(function () {
          selectedSlideRefreshQueued = false;
          refreshProductGallery(gallery, slideshow);
        });
      });

      selectedSlideObserver.observe(slideshow, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });

      var flickityReadyCheck = window.setInterval(function () {
        var flickity = window.Flickity && window.Flickity.data
          ? window.Flickity.data(slideshow)
          : slideshow.flickity || slideshow._flickity;

        if (!flickity) {
          return;
        }

        window.clearInterval(flickityReadyCheck);
        var syncGalleryCounter = function () {
          var selectedIndex = getFlickitySelectedIndex(flickity);

          updateProductThumbVisibility(gallery, slideshow);
          updateProductGalleryCount(gallery, selectedIndex);
        };

        flickity.on('select', syncGalleryCounter);
        flickity.on('settle', syncGalleryCounter);
        refreshProductGallery(gallery, slideshow);
      }, 250);

      window.setTimeout(function () {
        window.clearInterval(flickityReadyCheck);
      }, 5000);

      var initialRefreshes = 0;
      var initialRefreshCheck = window.setInterval(function () {
        initialRefreshes += 1;
        refreshProductGallery(gallery, slideshow);

        if (initialRefreshes >= 12) {
          window.clearInterval(initialRefreshCheck);
        }
      }, 250);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.mc-extra-offer__code');

    if (!button) {
      return;
    }

    var code = button.getAttribute('data-discount-code');
    var originalText = button.textContent;

    if (!code || !navigator.clipboard) {
      return;
    }

    navigator.clipboard.writeText(code).then(function () {
      button.textContent = 'COPIED';
      button.classList.add('is-copied');

      window.setTimeout(function () {
        button.textContent = originalText;
        button.classList.remove('is-copied');
      }, 1800);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductGalleryCounts(document);

      initLowStockMessages(document);
    });
  } else {
    initProductGalleryCounts(document);

    initLowStockMessages(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductGalleryCounts(event.target);

    initLowStockMessages(event.target);
  });

  document.addEventListener('change', refreshAllProductGalleries);
  document.addEventListener('variant:change', refreshAllProductGalleries);
  document.addEventListener('variantChange', refreshAllProductGalleries);
  document.addEventListener('variant:change', function (event) {
    document.querySelectorAll('.product-section').forEach(function (productSection) {
      updateLowStockMessage(productSection, event.detail && event.detail.variant);
    });
  });

  // Return to the very top after choosing a colour so the full sticky header and logo are visible.
  document.addEventListener('change', function (event) {
    var swatch = event.target;

    if (!swatch || !swatch.matches('input[type="radio"][data-color-name]') || !swatch.checked) {
      return;
    }

    window.setTimeout(function () {
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: 0,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }, 160);
  });

})();
